<template>
    <div class="main-wrapper" :class="type">
        <div class="header" ref="header">
            <div
                v-if="sideNavAvailable"
                class="slide-nav shadow d-flex flex-column"
                :class="{ open: slideNavVisible }"
            >
                <div
                    class="svg svg-upper head bg-white border-bottom text-center"
                >
                    <div
                        class="row no-gutters align-items-center bg-light-blue shadow-sm py-2 text-left head-sticky"
                    >
                        <div class="col-auto px-3" v-if="!wide">
                            <a class="pointer" @click.prevent="slideNavHide">
                                <CloseIcon></CloseIcon>
                            </a>
                        </div>
                        <div class="col" :class="{ 'pl-3': wide }">
                            <router-link
                                to="/"
                                v-if="!headUrl || wide"
                                class="position-relative d-block"
                            >
                                <img src="@/assets/logo-full.png" />
                                <!-- <span
                  style="
                    position: absolute;
                    left: 130px;
                    top: 15px;
                    font-size: 11px;
                    color: #888;
                  "
                >
                  0322 420 999
                </span> -->
                            </router-link>
                        </div>
                    </div>
                    <label class="avatar pointer mt-2" v-if="authUser">
                        <div
                            class="photo"
                            v-if="authAvatar"
                            :style="{
                                backgroundImage: `url(${staticUrl}${authAvatar})`,
                            }"
                        ></div>
                        <div class="py-4 px-2" v-else>
                            <user-icon></user-icon>
                        </div>
                        <input type="file" @change="handleFileChange" />
                    </label>
                    <h4 class="mt-2 text-center text-nowrap" v-if="authUser">
                        {{ authUser.firstname[authLocale] }}
                        {{ authUser.lastname[authLocale] }}
                    </h4>
                </div>
                <div class="w-100 d-flex flex-wrap flex-grow-1">
                    <div class="nav-items w-100 align-self-start">
                        <div class="svg border-bottom" v-if="!authUser">
                            <router-link
                                to="/doctors"
                                class="p-3 d-block nounderline d-flex justify-content-between"
                            >
                                <small class="text-muted uppercase pt-1">
                                    {{ $t("doctors") }}
                                </small>
                                <DoctorIcon></DoctorIcon>
                            </router-link>
                        </div>
                        <div class="svg border-bottom" v-if="!authUser">
                            <router-link
                                to="/services"
                                class="p-3 d-block nounderline d-flex justify-content-between"
                            >
                                <small class="text-muted uppercase pt-1">
                                    {{ $t("services") }}
                                </small>
                                <DiagnosticsIcon></DiagnosticsIcon>
                            </router-link>
                        </div>

                        <div
                            class="svg border-bottom"
                            v-if="type === 'Patient'"
                        >
                            <router-link
                                to="/p/monitoring"
                                class="p-3 d-block nounderline d-flex justify-content-between"
                            >
                                <small class="text-muted uppercase pt-1">
                                    {{ $t("monitoring") }}
                                </small>
                                <MonitoringIcon></MonitoringIcon>
                            </router-link>
                        </div>
                        <div
                            class="svg border-bottom"
                            v-if="type === 'Patient'"
                        >
                            <router-link
                                to="/p/cases"
                                class="p-3 d-block nounderline d-flex justify-content-between"
                            >
                                <small class="text-muted uppercase pt-1">
                                    {{ $t("medicalHistory") }}
                                </small>
                                <MedicalHistoryIcon></MedicalHistoryIcon>
                            </router-link>
                        </div>
                        <div
                            class="svg border-bottom"
                            v-if="type === 'Patient'"
                        >
                            <router-link
                                to="/p/interviews"
                                class="p-3 d-block nounderline d-flex justify-content-between"
                            >
                                <small class="text-muted uppercase pt-1">
                                    {{ $t("AIResults") }}
                                </small>
                                <SymptomCheckerIcon></SymptomCheckerIcon>
                            </router-link>
                        </div>
                        <div
                            class="svg border-bottom"
                            v-if="type === 'Patient'"
                        >
                            <router-link
                                to="/p/checkups"
                                class="p-3 d-block nounderline d-flex justify-content-between"
                            >
                                <small class="text-muted uppercase pt-1">
                                    {{ $t("checkups") }}
                                </small>
                                <CheckupIcon></CheckupIcon>
                            </router-link>
                        </div>
                        <div
                            class="svg border-bottom"
                            v-if="type === 'ClinicOperator'"
                        >
                            <router-link
                                to="/schedules"
                                class="p-3 d-block nounderline d-flex justify-content-between"
                            >
                                <small class="text-muted uppercase pt-1">
                                    განრიგი
                                </small>
                                <schedule-icon></schedule-icon>
                            </router-link>
                        </div>
                        <div class="svg border-bottom" v-if="type === 'Doctor'">
                            <router-link
                                to="/my/schedule"
                                class="p-3 d-block nounderline d-flex justify-content-between"
                            >
                                <small class="text-muted uppercase pt-1">
                                    ჩემი განრიგი
                                </small>
                                <schedule-icon></schedule-icon>
                            </router-link>
                        </div>
                        <div class="svg border-bottom" v-if="type === 'Doctor'">
                            <router-link
                                to="/my/schedule-manager"
                                class="p-3 d-block nounderline d-flex justify-content-between"
                            >
                                <small class="text-muted uppercase pt-1">
                                    განრიგის მართვა
                                </small>
                                <schedule-edit-icon></schedule-edit-icon>
                            </router-link>
                        </div>
                        <div
                            class="svg border-bottom"
                            v-if="type === 'ClinicOperator'"
                        >
                            <router-link
                                to="/clinic-doctors"
                                class="p-3 d-block nounderline d-flex justify-content-between"
                            >
                                <small class="text-muted uppercase pt-1">
                                    ექიმები
                                </small>
                                <doctor-icon></doctor-icon>
                            </router-link>
                        </div>
                    </div>
                    <div class="foot w-100 align-self-end">
                        <router-link
                            to="/login"
                            class="btn btn-block profile-btn text-primary text-truncate p-3 svg-upper"
                            :disabled="loading"
                            v-if="!authUser"
                        >
                            <small class="uppercase text-secondary">
                                {{ $t("login") }}
                            </small>
                            <LoginIcon></LoginIcon>
                        </router-link>
                        <router-link
                            to="/register"
                            class="btn btn-block profile-btn text-primary text-truncate p-3 svg-upper"
                            :disabled="loading"
                            v-if="!authUser"
                        >
                            <small class="uppercase text-secondary">
                                {{ $t("register") }}
                            </small>
                            <personal-info-icon></personal-info-icon>
                        </router-link>
                        <router-link
                            to="profile/personal-info"
                            class="btn btn-block profile-btn text-primary text-truncate p-3 svg-upper"
                            :disabled="loading"
                            v-if="authUser"
                        >
                            <small class="uppercase text-secondary">
                                {{ $t("personal-info") }}
                            </small>
                            <personal-info-icon></personal-info-icon>
                        </router-link>
                        <router-link
                            to="profile/contact-info"
                            class="btn btn-block profile-btn text-primary text-truncate p-3 disabled svg-upper"
                            :disabled="loading"
                            v-if="authUser"
                        >
                            <small class="uppercase text-secondary">
                                {{ $t("contact-info") }}
                            </small>
                            <contact-info-icon></contact-info-icon>
                        </router-link>
                        <router-link
                            to="profile/password"
                            class="btn btn-block profile-btn text-primary text-truncate p-3 svg-upper"
                            :disabled="loading"
                            v-if="authUser"
                        >
                            <small class="uppercase text-secondary">
                                {{ $t("change-password") }}
                            </small>
                            <password-icon></password-icon>
                        </router-link>
                        <a
                            class="btn btn-block profile-btn text-primary text-truncate p-3"
                            :disabled="loading"
                            @click.prevent="logout"
                            v-if="authUser"
                        >
                            <small class="uppercase text-secondary svg-upper">
                                {{ $t("logout") }}
                            </small>
                            <logout-icon></logout-icon>
                        </a>
                    </div>
                </div>
            </div>
            <div
                v-if="sideNavAvailable"
                class="head row align-items-center no-gutters flex-nowrap"
                :class="{ wide: wide }"
            >
                <div class="col-auto" v-if="!headUrl && !wide">
                    <a class="pl-3 pr-2 pointer" @click.prevent="slideNavShow">
                        <BarsIcon></BarsIcon>
                    </a>
                </div>
                <div class="col px-3">
                    <router-link
                        to="/"
                        v-if="!headUrl && !wide"
                        class="position-relative d-block"
                    >
                        <img src="@/assets/logo-full.png" />
                    </router-link>
                    <router-link
                        v-else-if="headUrl && typeof headUrl === 'string'"
                        :to="headUrl"
                        class="left"
                    >
                        <div
                            class="row no-gutters align-items-center flex-nowrap"
                        >
                            <div class="col-auto pr-3" v-if="!wide">
                                <back-icon></back-icon>
                            </div>
                            <div class="col-auto pr-2" v-if="headPhoto">
                                <div
                                    class="avatar"
                                    :style="{
                                        backgroundImage: `url(${staticUrl}${headPhoto})`,
                                    }"
                                    :class="{
                                        online:
                                            headUser && isOnline(headUser.id),
                                    }"
                                ></div>
                            </div>
                            <div class="col-auto text-truncate">
                                <strong>{{ headText }}</strong>
                                <small
                                    class="text-nowrap text-secondary d-block"
                                    >{{ headSubText }}</small
                                >
                            </div>
                        </div>
                    </router-link>
                    <a
                        v-else-if="headUrl === -1"
                        @click.prevent="$router.back()"
                        class="pointer left"
                    >
                        <div
                            class="row no-gutters align-items-center flex-nowrap"
                        >
                            <div class="col-auto pr-3" v-if="!wide">
                                <back-icon></back-icon>
                            </div>
                            <div class="col-auto pr-2" v-if="headPhoto">
                                <div
                                    class="avatar"
                                    :style="{
                                        backgroundImage: `url(${staticUrl}${headPhoto})`,
                                    }"
                                    :class="{
                                        online:
                                            headUser && isOnline(headUser.id),
                                    }"
                                ></div>
                            </div>
                            <div class="col-auto text-truncate">
                                <strong>{{ headText }}</strong>
                                <small
                                    class="text-nowrap text-secondary d-block"
                                    >{{ headSubText }}</small
                                >
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-auto pr-2 pr-md-3">
                    <div class="row no-gutters align-items-center">
                        <div
                            class="col-auto"
                            v-if="
                                !callChatId &&
                                chatById(chatId) &&
                                (chatById(chatId).type === 'PatientDoctor' ||
                                    chatById(chatId).type === 'DoctorClinic') &&
                                chatIsActive(chatId) &&
                                (type === 'Doctor' || type === 'ClinicOperator')
                            "
                        >
                            <a
                                href="#"
                                @click.prevent="call(chatId)"
                                class="mx-2 call-btn"
                                :class="{ online: headUser }"
                            >
                                <!-- && isOnline(headUser.id) -->
                                <video-call-icon></video-call-icon>
                            </a>
                        </div>
                        <div
                            class="col-auto"
                            v-if="
                                callChatId &&
                                chatById(callChatId) &&
                                chatById(callChatId).type === 'PatientDoctor' &&
                                chatIsActive(callChatId)
                            "
                        >
                            <a href="#" @click.prevent="hangup" class="mx-2">
                                <decline-call-icon></decline-call-icon>
                            </a>
                        </div>
                        <div class="col-auto">
                            <a
                                @click.prevent="slideNavToggle"
                                class="mx-2 avatar avatar-sm d-block pointer"
                                v-if="authAvatar"
                                :style="{
                                    backgroundImage: `url(${staticUrl}${authAvatar})`,
                                }"
                            >
                                <!-- <img v-if="authAvatar" :src="`${staticUrl}${authAvatar}`" /> -->
                            </a>
                            <a
                                @click.prevent="slideNavToggle"
                                class="mx-2 pointer"
                                v-else-if="authUser"
                            >
                                <user-icon></user-icon>
                            </a>
                            <a
                                v-if="!authUser"
                                to="/"
                                class="svg text-primary pointer"
                                @click.prevent="changeLocale"
                            >
                                <small class="pr-2 uppercase">{{
                                    $t(authLocale)
                                }}</small>
                                <LocaleIcon></LocaleIcon>
                            </a>
                            <router-link
                                v-if="!authUser && $route.name !== 'Login'"
                                to="/login"
                                class="svg-sm ml-3"
                            >
                                <small
                                    class="d-none d-md-inline-block pr-2 uppercase"
                                    >{{ $t("login") }}</small
                                >
                                <LoginIcon></LoginIcon>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div
            class="overflow-hidden wrapper"
            :class="{ wide: wide }"
            ref="content"
            @click="slideNavHide"
        >
            <div class="scroller" ref="scroller">
                <transition name="slide-fade">
                    <slot />
                </transition>
            </div>
            <loading v-if="loading"></loading>
        </div>
        <!-- <Navigation
      v-if="!authUser || (type === 'Patient' && navVisible)"
    ></Navigation> -->
    </div>
</template>
<script>
import Loading from "@/components/Loadings/Message";
// import Navigation from "@/components/Nav";
import UserIcon from "@/components/Icons/User";
import CheckupIcon from "@/components/Icons/Checkup";
import BackIcon from "@/components/Icons/Back";
// import ClinicIcon from "@/components/Icons/Clinic";
import VideoCallIcon from "@/components/Icons/VideoCall";
import DeclineCallIcon from "@/components/Icons/DeclineCall";
import MedicalHistoryIcon from "@/components/Icons/MedicalHistory";
import SymptomCheckerIcon from "@/components/Icons/SymptomChecker";
import BarsIcon from "@/components/Icons/Bars";
import ScheduleIcon from "@/components/Icons/Schedule";
import ScheduleEditIcon from "@/components/Icons/ScheduleEdit";
import CloseIcon from "@/components/Icons/Close";
import LogoutIcon from "@/components/Icons/Logout";
import PersonalInfoIcon from "@/components/Icons/PersonalInfo";
import ContactInfoIcon from "@/components/Icons/ContactInfo";
import PasswordIcon from "@/components/Icons/Password";
import LoginIcon from "@/components/Icons/Login";
import DoctorIcon from "@/components/Icons/Doctor";
import DiagnosticsIcon from "@/components/Icons/Diagnostics";
import LocaleIcon from "@/components/Icons/Locale";
import MonitoringIcon from "@/components/Icons/Monitoring";
import { mapGetters, mapActions, mapMutations } from "vuex";
export default {
    components: {
        // Navigation,
        Loading,
        UserIcon,
        BackIcon,
        CloseIcon,
        VideoCallIcon,
        DeclineCallIcon,
        MedicalHistoryIcon,
        SymptomCheckerIcon,
        CheckupIcon,
        BarsIcon,
        LogoutIcon,
        PersonalInfoIcon,
        ContactInfoIcon,
        PasswordIcon,
        LoginIcon,
        // ClinicIcon,
        LocaleIcon,
        ScheduleIcon,
        ScheduleEditIcon,
        DoctorIcon,
        DiagnosticsIcon,
        MonitoringIcon,
    },
    data() {
        return {
            chatId: null,
            loading: false,
            slideNavVisible: false,
            wide: false,
        };
    },
    computed: {
        ...mapGetters({
            staticUrl: "app/staticUrl",
            authAvatar: "auth/avatar",
            authUser: "auth/user",
            authLocale: "auth/locale",
            type: "auth/type",
            headUrl: "head/url",
            headText: "head/text",
            headSubText: "head/subText",
            headPhoto: "head/photo",
            headUser: "head/user",
            isOnline: "status/isOnline",
            chatById: "chat/byId",
            chatIsActive: "chat/isActive",
            callChatId: "call/chatId",
            callStatus: "call/status",
            isMuted: "call/muted",
            isCompact: "call/compact",
            headHeight: "head/height",
            width: "app/width",
            windowHeight: "app/height",
            navVisible: "app/navVisible",
            scrolledToBottom: "app/scrolledToBottom",
        }),
        sideNavAvailable() {
            return this.authUser;
        },
    },
    watch: {
        callStatus(val) {
            if (val !== "pending") {
                this.loading = false;
            }
        },
        headHeight(val) {
            this.$refs.header.style.height = `${val}px`;
            this.$refs.content.style.height = `${this.windowHeight - val}px`;
        },
        windowHeight(val) {
            let height = val;
            if (this.authUser) {
                height -= this.headHeight;
            }
            // const height = val; // - this.headHeight;
            if (
                this.navVisible &&
                (this.type === "Patient" || !this.authUser)
            ) {
                // height -= 76;
            }
            this.$refs.content.style.height = `${height}px`;
        },
        // width (val) {
        // if (val > 1000 && !this.authUser) {
        //   this.wide = true
        //   this.slideNavVisible = true
        // } else {
        // this.wide = false
        // this.slideNavVisible = false
        // }
        // },
        authUser(val) {
            if (val) {
                this.wide = false;
            } else if (this.width > 1000) {
                this.wide = true;
                this.slideNavVisible = true;
            }
        },
        navVisible(val) {
            let height = this.windowHeight - this.headHeight;
            if (val && (this.type === "Patient" || !this.authUser)) {
                height -= 76;
            }
            this.$refs.content.style.height = `${height}px`;
        },
        $route: {
            deep: true,
            handler(val) {
                this.slideNavHide();
                this.setNavVisible(true);
                if (this.$refs.scroller) {
                    this.$refs.scroller.scrollTop = 0;
                }
                this.chatId = null;
                if (val.name === "Chat" && val.params.id) {
                    this.chatId = val.params.id;
                    this.fetchChat(val.params.id);
                }
                this.inputScroller();
            },
        },
    },
    mounted() {
        this.refreshHeight();
        this.inputScroller();
        // const interval =

        setInterval(() => {
            if (!this.$refs.scroller) {
                return;
            }
            if (this.scrolledToBottom > 10) {
                // clearInterval(interval)
                return;
            }
            // console.log(this.$refs.scroller.scrollTop, this.$refs.scroller.clientHeight, this.$refs.scroller.scrollHeight)
            if (
                this.$refs.scroller.scrollTop === 0 &&
                this.$refs.scroller.clientHeight ===
                    this.$refs.scroller.scrollHeight
            ) {
                this.setScrolledToBottom(this.scrolledToBottom + 1);
            } else {
                // clearInterval(interval)
            }
        }, 1000);
        this.$refs.scroller.addEventListener("scroll", (e) => {
            const el = e.target;
            if (el.scrollTop + el.clientHeight >= el.scrollHeight) {
                this.setScrolledToBottom(this.scrolledToBottom + 1);
            } else {
                this.setScrolledToBottom(0);
            }
        });
    },
    methods: {
        ...mapActions({
            fetchChat: "chat/fetchChat",
            initCall: "call/initCall",
            authFetch: "auth/fetch",
        }),
        ...mapMutations({
            hangup: "call/finish",
            muteToggle: "call/muteToggle",
            screenToggle: "call/screenToggle",
            refreshHeight: "app/refreshHeight",
            setNavVisible: "app/setNavVisible",
            setScrolledToBottom: "app/setScrolledToBottom",
            setToken: "auth/setToken",
            setUser: "auth/setUser",
            setError: "auth/setError",
            setLocale: "auth/setLocale",
        }),
        changeLocale() {
            if (this.authLocale === "ka") {
                this.setLocale("en");
            } else {
                this.setLocale("ka");
            }
        },
        slideNavToggle() {
            this.slideNavVisible = !this.slideNavVisible;
        },
        slideNavHide() {
            if (!this.wide) {
                this.slideNavVisible = false;
            }
        },
        slideNavShow() {
            this.slideNavVisible = true;
        },
        inputScroller() {
            const inputs = this.$refs.scroller.getElementsByTagName("input");
            for (const input of inputs) {
                if (input.closest(".scrollto")) {
                    input.addEventListener("focus", () => {
                        setTimeout(() => {
                            this.$refs.scroller.scrollTo(
                                0,
                                input.closest(".scrollto").offsetTop,
                            );
                        }, 500);
                    });
                }
            }
        },
        call(chatId) {
            // || !this.isOnline(this.headUser.id)
            if (!this.headUser) {
                return;
            }
            this.loading = true;
            this.initCall(chatId);
        },
        handleFileChange(e) {
            const file = e.target.files[0];
            this.uploadAvatar(file);
        },
        async uploadAvatar(file) {
            try {
                const formData = new FormData();
                formData.append("file", file);
                await this.axios.post("/api/profile/avatar", formData, {
                    headers: { "Content-Type": "multipart/form-data" },
                });
                this.authFetch();
            } catch (err) {
                this.setError(err);
            }
        },
        logout() {
            this.$store.commit("auth/setToken", null);
            this.$store.commit("auth/setUser", null);
            this.$cookie.delete("session");
            window.location.href = "/";
        },
    },
};
</script>
<style lang="scss">
.wide {
    padding-left: 268px;
}
.header {
    .slide-nav {
        overflow: auto;
        height: 100%;
        position: fixed;
        width: 268px;
        left: -268px;
        background: #fff;
        z-index: 999999;
        transition: all 0.2s ease;
        &.open {
            left: 0;
        }
        .head {
            width: 100%;
            height: auto;
            position: relative;
            &.wide {
                padding-left: 268px;
            }
            .head-sticky {
                position: sticky;
                top: 0;
                z-index: 1001;
            }
            .close {
                position: absolute;
                top: 10px;
                right: 10px;
            }
            .avatar {
                width: 100px;
                height: 100px;
                box-shadow:
                    0 14px 28px rgba(0, 0, 0, 0.25),
                    0 10px 10px rgba(0, 0, 0, 0.22);
                border-radius: 70px;
                overflow: hidden;
                .photo {
                    width: 100px;
                    height: 100px;
                    background-size: cover;
                    background-position: center;
                }
                input[type="file"] {
                    display: none;
                }
            }
        }
        .nav-items {
            a {
                &:hover {
                    background-color: #eee;
                }
            }
            .router-link-exact-active {
                background-color: #3c88ff;
                color: #fff !important;
                small {
                    color: #fff !important;
                }
                &:hover {
                    background-color: #3c88ff !important;
                }
            }
        }
        .foot {
            width: 100%;
            // height: 214px;
            margin-top: 4em;
            .profile-btn {
                margin: 0;
                border-top: 1px solid #e3e3e3;
                display: flex;
                justify-content: space-between;
                &:hover {
                    background-color: #eee;
                }
                svg {
                    width: 16px;
                    height: 16px;
                }
            }
        }
    }
}
</style>
<i18n>
{
  "ka": {
      "myProfile": "ჩემი პროფილი",
      "logout": "გამოსვლა",
      "personal-info": "პირადი ინფორმაცია",
      "contact-info": "საკონტაქტო ინფორმაცია",
      "change-password": "პაროლის შეცვლა",
      "login": "შესვლა",
      "register": "რეგისტრაცია",
      "home": "მთავარი",
      "doctors": "ექიმები",
      "services": "სერვისები",
      "ka": "English",
      "monitoring": "მონიტორინგი",
      "medicalHistory": "სამედიცინო ისტორია",
      "AIResults": "AI დასკვნები",
      "checkups": "ექსპრეს სკრინინგები"
  },
  "en": {
      "myProfile": "My Profile",
      "logout": "Logout",
      "personal-info": "Personal Info",
      "contact-info": "Contact Info",
      "change-password": "Change Password",
      "login": "Login",
      "register": "Register",
      "home": "Home",
      "doctors": "Doctors",
      "services": "Services",
      "en": "ქართული",
      "monitoring": "Monitoring",
      "medicalHistory": "Medical Histroy",
      "AIResults": "AI Results",
      "checkups": "Checkups"
  }
}
</i18n>
